import { render, staticRenderFns } from "./PrintImage.vue?vue&type=template&id=472a8cfa&scoped=true&"
import script from "./PrintImage.vue?vue&type=script&lang=js&"
export * from "./PrintImage.vue?vue&type=script&lang=js&"
import style0 from "./PrintImage.vue?vue&type=style&index=0&id=472a8cfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472a8cfa",
  null
  
)

export default component.exports